__turbopack_context__.v({
  "articleCard": "ArticleCard-module-scss-module__nADRbG__articleCard",
  "imageWrap": "ArticleCard-module-scss-module__nADRbG__imageWrap",
  "link": "ArticleCard-module-scss-module__nADRbG__link",
  "text": "ArticleCard-module-scss-module__nADRbG__text",
});
